import cn from 'classnames';
import { FC } from 'react';

import { Avatar, Icon } from '@/shared/ui';

import { OrganizationMember } from '@/entities/organization';
import { useDoctorDetails } from '@/entities/organization/hooks/useDoctorDetails';

import styles from './DoctorRow.module.scss';

type DoctorRowProps = {
  doctor: OrganizationMember;
  className?: string;
  description?: JSX.Element | string;
  disabled?: boolean;
  onDelete?: () => void;
};

export const DoctorRow: FC<DoctorRowProps> = (props) => {
  const { doctor, className, description, disabled, onDelete } = props;

  const { doctorFullName, doctorInitials, doctorAvatarSrc } =
    useDoctorDetails(doctor);

  return (
    <div
      className={cn(styles.container, disabled && styles.disabled, className)}
      data-component="doctor-row"
    >
      <Avatar
        src={doctorAvatarSrc}
        alt={doctorFullName}
        initials={doctorInitials}
      />
      <div className={styles.content}>
        <h5 className={cn(styles.title, 'p2')}>{doctorFullName}</h5>

        <p className={cn(styles.description, 'p3')}>{description}</p>
      </div>

      {onDelete ? (
        <button type="button" className={styles.button} onClick={onDelete}>
          <Icon name="delete" size={32} />
        </button>
      ) : null}
    </div>
  );
};
